import { useBankOperationEditable } from 'pages/Finance/BankOperations/hooks/useBankOperationEditable';
import { useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { useGetFiles } from 'shared/widgets/TableFileViewer/hooks/useGetFiles';
import { TableFileViewer } from 'shared/widgets/TableFileViewer/TableFileViewer';
import { BankOperation } from 'types/embedded/bankOperation';

export const BankOperationsShowTabsFiles: React.FC = () => {
  const record = useRecordContext<BankOperation>();
  const { checkBankOperationEditable } = useBankOperationEditable();

  const { data: files } = useGetFiles('bank_operation', record?.originId);

  return record && (checkBankOperationEditable(record) || (files && files.length > 0)) ? (
    <TableFileViewer
      allowUpdate={checkBankOperationEditable(record)}
      entityId={record.originId}
      entityName="bank_operation"
    />
  ) : (
    <Alert severity="info">Файлы отсутствуют</Alert>
  );
};
